import React, { useEffect } from 'react';
import { DashboardSkeleton } from 'pages/ReportsPage/components/AnalyticsDashboards/Skeleton';
import { useTranslation } from 'hooks/useTranslation';
import { useAnalyticsFilterStore } from 'pages/ReportsPage/store/analyticsFilterView.context';
import { useLaborProductivityDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborProductivityDashboard/store/laborProductivityDashboard.store';
import { FilterBar } from 'pages/ReportsPage/components/AnalyticsDashboards/FilterBar';
import { WidgetCardWrapper } from 'pages/ReportsPage/components/AnalyticsDashboards/WidgetCardWrapper';
import { ActiveMembersByPositionChart } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborProductivityDashboard/ActiveMembersByPositionChart';
import { CalloutShiftsByTypeChart } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborProductivityDashboard/CalloutShiftsByTypeChart';
import {
  DashboardContainer,
  DashboardHeader,
  DashboardContent,
  DashboardTitle,
  DashboardErrorContainer,
  WidgetGrid,
} from 'pages/ReportsPage/components/AnalyticsDashboards/LaborProductivityDashboard/LaborProductivityDashboard.styled';

export const LaborProductivityDashboard: React.FC = () => {
  const { t } = useTranslation();
  const fetchData = useLaborProductivityDashboardStore((s) => s.fetchData);
  const reset = useLaborProductivityDashboardStore((s) => s.reset);
  const isLoading = useLaborProductivityDashboardStore((s) => s.isLoading);
  const error = useLaborProductivityDashboardStore((s) => s.error);
  const dateRange = useAnalyticsFilterStore((s) => s.dateRange);
  const locationIds = useAnalyticsFilterStore((s) => s.locationIds);
  const employmentTypes = useAnalyticsFilterStore((s) => s.employmentTypes);
  const positions = useAnalyticsFilterStore((s) => s.positions);
  const showSkeleton = isLoading;

  useEffect(() => {
    return fetchData(dateRange, locationIds, positions, employmentTypes);
  }, [fetchData, dateRange, locationIds, employmentTypes, positions]);

  useEffect(() => {
    return () => reset();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <DashboardContainer aria-label={t('reports:LABOR_PRODUCTIVITY_DASHBOARD_TITLE')}>
      <DashboardHeader>
        <DashboardTitle>{t('reports:LABOR_PRODUCTIVITY_DASHBOARD_TITLE')}</DashboardTitle>
      </DashboardHeader>
      <FilterBar />
      <DashboardContent>
        {error ? (
          <div aria-live="assertive">
            <DashboardErrorContainer>{error}</DashboardErrorContainer>
          </div>
        ) : showSkeleton ? (
          <DashboardSkeleton kpiCount={0} widgetCount={2} />
        ) : (
          <WidgetGrid>
            <WidgetCardWrapper
              title={t('reports:ACTIVE_MEMBERS_BY_POSITION_TITLE')}
              subtitle={t('reports:ACTIVE_MEMBERS_BY_POSITION_SUBTITLE')}
            >
              <ActiveMembersByPositionChart />
            </WidgetCardWrapper>
            <WidgetCardWrapper
              title={t('reports:CALLOUT_SHIFTS_BY_TYPE_TITLE')}
              subtitle={t('reports:CALLOUT_SHIFTS_BY_TYPE_SUBTITLE')}
            >
              <CalloutShiftsByTypeChart />
            </WidgetCardWrapper>
          </WidgetGrid>
        )}
      </DashboardContent>
    </DashboardContainer>
  );
};
